import { render, staticRenderFns } from "./STBConfig.vue?vue&type=template&id=43efe666&scoped=true"
import script from "./STBConfig.vue?vue&type=script&lang=js"
export * from "./STBConfig.vue?vue&type=script&lang=js"
import style0 from "./STBConfig.vue?vue&type=style&index=0&id=43efe666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43efe666",
  null
  
)

export default component.exports